import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import { QueryProvider } from './QueryProvider';
import { LegacyAuthProvider } from './AuthProvider';
import { UnifiedAuthProvider } from './UnifiedAuthProvider';
import { BrandingLoader } from './BrandingLoader';
import { ThemeProvider } from './ThemeProvider';
import { oidcConfig } from '@shared/config/oidc';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryProvider>
      <LegacyAuthProvider>
        <OidcAuthProvider {...oidcConfig}>
          <UnifiedAuthProvider>
            <BrandingLoader>
              {(brandingTokens) => (
                <ThemeProvider brandingTokens={brandingTokens}>{children}</ThemeProvider>
              )}
            </BrandingLoader>
          </UnifiedAuthProvider>
        </OidcAuthProvider>
      </LegacyAuthProvider>
    </QueryProvider>
  );
}
